import MongoMedia from "./media";

export default class MongoMediaEngine {
  static fromJson(json) {
    var media = new MongoMedia(json.type, json.url);
    return media;
  }
}
